"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.evaluatedAtBackfill = evaluatedAtBackfill;
exports.examTypeToTypeMapping = examTypeToTypeMapping;
exports.fromResponseLegacyFields = fromResponseLegacyFields;
exports.getResponseStatus = getResponseStatus;
exports.responseAnswerIds = responseAnswerIds;
exports.responseEvaluation = responseEvaluation;
exports.responseSelectedAnswers = responseSelectedAnswers;
exports.startsWithCapital = startsWithCapital;
// I'd like to change the Response Factory to an Immutable Record type so that we can implement
// these methods on the Response objects themselves.
// We haven't done this yet because benchmark tests have shown that the Record type is less
// performant than using a Map.

function responseAnswerIds(response) {
  var _answerIds;
  var ungraded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var answerIds = response.get(ungraded ? 'ungraded_user_input' : 'user_input');
  answerIds = answerIds ? JSON.parse(answerIds) : answerIds;
  return (_answerIds = answerIds) !== null && _answerIds !== void 0 ? _answerIds : [];
}
function getResponseStatus(response) {
  var ungraded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var questionList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isMulti = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (ungraded) {
    if (response.get('ungraded_user_input') !== null) {
      if (response.get('ungraded_correct') !== null) {
        return response.get('ungraded_correct') ? 'correct' : 'incorrect';
      }
      return 'unevaluated';
    } else if (response.get('user_input') === null || !isMulti && response.get('user_input').length === 0 || isMulti && response.get('user_input') === '[]') {
      return 'unanswered';
    } else if (response.get('correct') !== null) {
      return response.get('correct') ? 'correct' : 'incorrect';
    }
    return 'unevaluated';
  } else {
    if (response.get('user_input') === null || !isMulti && response.get('user_input').length === 0 || isMulti && response.get('user_input') === '[]') {
      // This is only used in the question list filter where graded unanswered = incorrect
      if (response.get('correct') !== null && questionList) {
        return response.get('correct') ? 'correct' : 'incorrect';
      }
      return 'unanswered';
    } else if (response.get('correct') !== null) {
      return response.get('correct') ? 'correct' : 'incorrect';
    }
    return 'unevaluated';
  }
}
function responseEvaluation(response, question) {
  var ungraded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!response) return false;
  var inputAttribute = ungraded ? 'ungraded_user_input' : 'user_input';
  switch (question.get('type')) {
    case 'SortableQuestion':
      {
        var correctAnswerIds = question.get('answers').sortBy(function (answer) {
          return answer.get('choice');
        }).map(function (answer) {
          return answer.get('id');
        }).join();
        var answerIds = responseAnswerIds(response, ungraded).join();
        return correctAnswerIds === answerIds;
      }
    case 'HotspotQuestion':
      {
        // The grading logic for hotspot is dependent on the onPress native event coordinates matching the svg polygon coordinates
        // hotspot_hit is only added if user presses to set the response, but not if we are reloading the question after leaving the quiz, since there is no onPress event.
        // In that case we need to rely on the previous cached answer which is the one rendered on the screen
        var inputParts = response.get(inputAttribute, '').split(',');
        if (inputParts.length >= 3) return inputParts[2] === 'true';
        return !!response.get('correct');
      }
    case 'OpenEndedQuestion':
      // We can't automatically evaluate Open Ended Questions so we automatically
      // set it to 'correct' if any answer at all has been provided.
      return response.get(inputAttribute).length > 0;
    case 'FillInBlankQuestion':
      {
        var correctAnswer = question.get('answers').toList().find(function (answer) {
          return answer.get('is_correct');
        });
        return correctAnswer.get('plain_name').toLowerCase().trim() === response.get(inputAttribute).toLowerCase().trim();
      }
    case 'MultipleChoiceQuestion':
    case 'GraphicChoiceQuestion':
    default:
      {
        var _correctAnswerIds = question.get('correct_answer_ids').toArray();
        var _answerIds2 = responseAnswerIds(response, ungraded);
        return _answerIds2.length === _correctAnswerIds.length && _answerIds2.every(function (id) {
          return _correctAnswerIds.includes(id);
        });
      }
  }
}
function responseSelectedAnswers(response, questionType) {
  var ungraded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!response) return null;
  switch (questionType) {
    case 'HotspotQuestion':
    case 'OpenEndedQuestion':
    case 'FillInBlankQuestion':
      return response.get(ungraded ? 'ungraded_user_input' : 'user_input');
    case 'SortableQuestion':
    case 'MultipleChoiceQuestion':
    case 'GraphicChoiceQuestion':
    default:
      return responseAnswerIds(response, ungraded);
  }
}
function fromResponseLegacyFields(response, questions) {
  var cachedState = response.get('cached_state');
  var questionId = response.get('question_id');
  var question = !!questions && questions.find(function (q) {
    return q.get('id') === questionId;
  });
  var correctValue = null;
  var userInput = null;
  if (cachedState === 'correct') {
    correctValue = true;
  } else if (cachedState === 'incorrect') {
    correctValue = false;
  }
  if (cachedState !== 'unanswered' && !!question) {
    switch (question.get('type')) {
      case 'SortableQuestion':
        var sortable_answer = [];
        response.get('sortable_answer').toArray().map(function (a) {
          return sortable_answer.push(a);
        });
        userInput = JSON.stringify(sortable_answer);
        break;
      case 'HotspotQuestion':
        userInput = response.get('hotspot_answer');
        break;
      case 'OpenEndedQuestion':
        userInput = response.get('open_ended_answer');
        break;
      case 'FillInBlankQuestion':
        userInput = response.get('fill_in_answer');
        break;
      case 'MultipleChoiceQuestion':
      case 'GraphicChoiceQuestion':
      default:
        /* eslint-disable-next-line no-case-declarations */
        var answer = [];
        response.get('answer_ids').toArray().map(function (a) {
          return answer.push(a);
        });
        userInput = JSON.stringify(answer);
        break;
    }
  }
  return response.set('correct', correctValue).set('user_input', userInput).set('ungraded_correct', null).set('ungraded_user_input', null);
}
function evaluatedAtBackfill(response) {
  var evaluatedAt = response.get('evaluated_at');
  var updatedAt = response.get('updated_at');
  var userInput = response.get('user_input');
  var correct = response.get('correct');
  if (!!updatedAt && evaluatedAt === null && correct !== null && userInput === null) {
    return response.set('evaluated_at', updatedAt);
  }
  return response;
}
function startsWithCapital(word) {
  /*eslint-disable-next-line */
  return !!word ? word.charAt(0) === word.charAt(0).toUpperCase() : false;
}
function examTypeToTypeMapping(examType) {
  if (examType === 'Review') {
    return 'study';
  } else if (examType === 'Untimed' || examType === 'Timed') {
    return 'test';
  } else if (examType === 'Adaptive') {
    return 'adaptive';
  } else if (examType === 'Tutor') {
    return 'tutor';
  }
  return examType;
}